// import lib
import { lazy } from "react";

const routes = [
  {
    path: "/user_profile",
    element: lazy(() => import("../../pages/UserAccess/UserProfile/index")),
  },
  {
    path: "/user_profile/add",
    element: lazy(() =>
      import("../../pages/UserAccess/UserProfile/create-edit")
    ),
  },
  {
    path: "/user_profile/edit/:id",
    element: lazy(() =>
      import("../../pages/UserAccess/UserProfile/create-edit")
    ),
  },
];

export default routes;
